/**
 * HALAL ICHIBA カスタムJavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  // 不要な商品ページアコーディオンセクションを非表示
  const hideProductSections = [
    'Product features',
    'Materials and care',
    'Merchandising tips'
  ];

  const accordions = document.querySelectorAll('.product__accordion');

  accordions.forEach(accordion => {
    const titleElement = accordion.querySelector('.accordion__title');

    if (titleElement) {
      const titleText = titleElement.textContent.trim();

      if (hideProductSections.includes(titleText)) {
        accordion.style.display = 'none';
      }
    }
  });

  // サイト全体の価格からJPYを削除＆フォントサイズ強制
  function removeJPYFromPrice() {
    // サイト全体の価格要素を対象
    const priceElements = document.querySelectorAll('.price, .price-item, [id*="price"], .money, .cart-item__price, .totals__subtotal-value, .cart__subtotal');

    priceElements.forEach(element => {
      // 全テキストノードを走査してJPYを削除
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null
      );

      let node;
      const nodesToUpdate = [];

      while (node = walker.nextNode()) {
        if (node.nodeValue && node.nodeValue.includes('JPY')) {
          nodesToUpdate.push(node);
        }
      }

      nodesToUpdate.forEach(node => {
        node.nodeValue = node.nodeValue.replace(/\s*JPY\s*/g, '');
      });
    });
  }

  // 価格のフォントサイズを強制適用 (セール商品は除外 — halal-price-fix.css の SALE スタイルが効くように)
  function enforcePriceFontSize() {
    const priceItems = document.querySelectorAll('.price-item, .price-item--regular, .price-item--sale, .price-item--last, span.money');
    priceItems.forEach(el => {
      // セール価格コンテキスト内 (.price--on-sale の子孫) は CSS に任せる
      if (el.closest('.price--on-sale')) {
        return;
      }
      // 商品詳細ページ
      if (el.closest('.product__info-wrapper') || el.closest('.price--large')) {
        el.style.setProperty('font-size', '3rem', 'important');
      } else {
        el.style.setProperty('font-size', '1.5rem', 'important');
      }
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('color', '#0e6e2b', 'important');
    });
  }

  // サイト全体で実行
  removeJPYFromPrice();
  enforcePriceFontSize();

  // 遅延実行（動的に価格が変わる場合に対応）
  setTimeout(function() { removeJPYFromPrice(); enforcePriceFontSize(); }, 200);
  setTimeout(function() { removeJPYFromPrice(); enforcePriceFontSize(); }, 500);
  setTimeout(function() { removeJPYFromPrice(); enforcePriceFontSize(); }, 1000);
  setTimeout(function() { removeJPYFromPrice(); enforcePriceFontSize(); }, 2000);

  // MutationObserverでDOM変更を監視
  let priceTimeout;
  const priceObserver = new MutationObserver(function(mutations) {
    clearTimeout(priceTimeout);
    priceTimeout = setTimeout(function() {
      removeJPYFromPrice();
      enforcePriceFontSize();
    }, 50);
  });

  priceObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 商品ページの（税込）表示
  if (document.querySelector('.product')) {
    // （税込）をprice__containerの直後に挿入
    function addTaxLabel() {
      // price-wrapperまたは価格エリアを探す
      const priceWrapper = document.querySelector('.product .price-wrapper') ||
                           document.querySelector('.product [id*="price"]');

      if (!priceWrapper) return;

      // 既に追加済みかチェック
      if (document.querySelector('.product .price-tax-label')) {
        return;
      }

      // price__containerまたはpriceを探す
      const priceContainer = priceWrapper.querySelector('.price__container') ||
                            priceWrapper.querySelector('.price');

      if (!priceContainer) return;

      // （税込）ラベルを作成
      const taxLabel = document.createElement('span');
      taxLabel.className = 'price-tax-label';
      taxLabel.textContent = ' （税込）';

      // price__containerの直後に挿入
      priceContainer.insertAdjacentElement('afterend', taxLabel);
    }

    // 複数回実行
    addTaxLabel();
    setTimeout(addTaxLabel, 100);
    setTimeout(addTaxLabel, 300);
    setTimeout(addTaxLabel, 500);
    setTimeout(addTaxLabel, 1000);
  }

  // Custlo Customer Dashboard 英語→日本語置換
  function translateCustloDashboard() {
    const translations = {
      // 最近見た商品ページ
      'Recently viewed products': '最近見た商品',
      "You haven't checked out our latest product additions. Find an extensive range of quality items within our inventory. Explore our products now!": 'まだ商品を閲覧していません。商品一覧から気になる商品をチェックしてみてください。',
      'View products': '商品を見る',
      // よく購入した商品ページ
      'Top ordered products': 'よく購入した商品',
      "You haven't placed any orders yet.": 'まだ注文履歴がありません。',
      // サイドバーメニュー
      'My profile': 'マイプロフィール',
      'Orders': '注文履歴',
      'Addresses': '住所管理',
      'Change password': 'パスワード変更',
      'Recently viewed': '最近見た商品',
      'Logout': 'ログアウト',
      // ボタン
      'Save': '保存する',
      'Edit': '編集',
      'Delete': '削除',
      'Cancel': 'キャンセル',
      'Add new address': '新しい住所を追加',
      'Set as default': 'デフォルトに設定',
      // フォームラベル
      'First name': '姓',
      'Last name': '名',
      'Email': 'メールアドレス',
      'Phone': '電話番号',
      'Company': '会社名',
      'Address': '住所',
      'City': '市区町村',
      'Country': '国',
      'Province': '都道府県',
      'Postal/Zip code': '郵便番号',
      'Zip code': '郵便番号',
      'Postal code': '郵便番号',
      // パスワード変更
      'Current password': '現在のパスワード',
      'New password': '新しいパスワード',
      'Confirm password': '新しいパスワード（確認）',
      // 注文履歴
      'Order history': '注文履歴',
      'No orders yet': 'まだ注文がありません',
      'View order': '注文を見る',
      'Reorder': '再注文'
    };

    // テキストノードを置換
    function replaceText(element) {
      if (element.nodeType === Node.TEXT_NODE) {
        let text = element.nodeValue;
        for (const [eng, jpn] of Object.entries(translations)) {
          if (text.includes(eng)) {
            text = text.replace(new RegExp(eng.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), jpn);
          }
        }
        element.nodeValue = text;
      } else {
        element.childNodes.forEach(replaceText);
      }
    }

    // Custloダッシュボード要素を探して置換
    const custloContainer = document.getElementById('customer_dashboard');
    if (custloContainer) {
      replaceText(custloContainer);
    }
  }

  // Custloダッシュボードが存在する場合のみ実行
  if (document.getElementById('customer_dashboard')) {
    // 初回実行
    translateCustloDashboard();
    // 遅延実行（動的コンテンツ対応）
    setTimeout(translateCustloDashboard, 500);
    setTimeout(translateCustloDashboard, 1000);
    setTimeout(translateCustloDashboard, 2000);

    // MutationObserverで動的変更を監視
    const custloObserver = new MutationObserver(function(mutations) {
      translateCustloDashboard();
    });

    const custloContainer = document.getElementById('customer_dashboard');
    if (custloContainer) {
      custloObserver.observe(custloContainer, {
        childList: true,
        subtree: true
      });
    }
  }

  // カート追加通知 - 独自トースト
  function showCartToast(message) {
    // 既存のトーストを削除
    const existingToast = document.getElementById('halal-cart-toast');
    if (existingToast) {
      existingToast.remove();
    }

    // トースト作成
    const toast = document.createElement('div');
    toast.id = 'halal-cart-toast';
    toast.innerHTML = `
      <div class="halal-cart-toast__content">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm-2 15l-5-5 1.41-1.41L8 12.17l7.59-7.59L17 6l-9 9z" fill="#0e6e2b"/>
        </svg>
        <span>${message}</span>
      </div>
      <a href="/cart" class="halal-cart-toast__btn">カートを見る</a>
    `;
    document.body.appendChild(toast);

    // スタイル追加（初回のみ）
    if (!document.getElementById('halal-cart-toast-style')) {
      const style = document.createElement('style');
      style.id = 'halal-cart-toast-style';
      style.textContent = `
        #halal-cart-toast {
          position: fixed;
          top: 100px;
          right: 20px;
          background: #fff;
          border: 2px solid #0e6e2b;
          border-radius: 8px;
          padding: 1rem 1.5rem;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          z-index: 99999;
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          animation: slideIn 0.3s ease;
          max-width: 320px;
        }
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOut {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
        .halal-cart-toast__content {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          color: #0e6e2b;
          font-weight: 600;
          font-size: 1.25rem;
        }
        .halal-cart-toast__content svg {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }
        #halal-cart-toast .halal-cart-toast__btn,
        .halal-cart-toast__btn,
        a.halal-cart-toast__btn {
          background: #0e6e2b !important;
          color: #fff !important;
          text-decoration: none !important;
          padding: 0.75rem 1.25rem !important;
          border-radius: 4px !important;
          text-align: center !important;
          font-weight: 600 !important;
          font-size: 1rem !important;
          display: block !important;
        }
        #halal-cart-toast .halal-cart-toast__btn:hover,
        .halal-cart-toast__btn:hover,
        a.halal-cart-toast__btn:hover {
          background: #0a5a23 !important;
          color: #fff !important;
        }
      `;
      document.head.appendChild(style);
    }

    // 4秒後に自動で消える
    setTimeout(() => {
      toast.style.animation = 'slideOut 0.3s ease';
      setTimeout(() => toast.remove(), 300);
    }, 4000);
  }

  // fetch APIをオーバーライドしてカート追加を検知
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      const url = args[0];
      if (typeof url === 'string' && url.includes('/cart/add')) {
        response.clone().json().then(data => {
          if (data && !data.status) {
            showCartToast('カートに追加しました');
          }
        }).catch(() => {});
      }
      return response;
    });
  };
});
